import { createAppUrl } from 'utils/url/createAppUrl';
import { convertFiltersObjectToString } from '../filters/convertFilters';
import { convertSortObjectToString } from '../sort/convertSort';
/**
 * Creates a Search URL with supported path and query parameters.
 *
 * @param tab The current Search tab
 * @param params The current Search parameters
 */
export function createSearchUrl(tab, params) {
    const { query, filters, strict, page, sort } = params;
    const url = createAppUrl({
        path: '/search/:tab',
        params: {
            path: {
                tab,
            },
            search: {
                q: query || undefined,
                filters: convertFiltersObjectToString(filters) || undefined,
                sort: convertSortObjectToString(sort) || undefined,
                strict: strict ? 'true' : undefined,
                page: page && page > 1 ? page.toString() : undefined,
            },
        },
    });
    return url;
}
